const topBarHeight = '84px'
const smartNavigatorHeaderPadding = '3rem'
const smartNavigatorHeaderHeight = '48px'
const smartNavigatorPadding = '48px'
const FOOTER_HEIGHT = '56px'
const accordion = '48px'
const cabeceraJob = '88px'
const paddingAccordion = '32px'
const balancedHeader = '5rem'

const FULL_HEIGHT = {
  WITH_NAV_BAR: 'calc(100vh - ' + topBarHeight + ')',
  WITH_NAV_BAR_AND_SMART_NAVIGATOR_AND_FOOTER: 'calc(100vh - ' + topBarHeight + ' - ' + smartNavigatorHeaderPadding + ' - ' + smartNavigatorPadding + ' - ' + smartNavigatorHeaderHeight + ' - ' + FOOTER_HEIGHT + ')',
  JOB_LINKER_REACTFLOW: 'calc(100vh - ' + topBarHeight + ' - ' + smartNavigatorHeaderPadding + ' - ' + smartNavigatorPadding + ' - ' + smartNavigatorHeaderHeight + ' - ' + FOOTER_HEIGHT + ' - ' + cabeceraJob + ' - ' + paddingAccordion + ' - ' + accordion + ')',
  BALANCED: 'calc(100vh - ' + topBarHeight + ' - ' + smartNavigatorHeaderPadding + ' - ' + smartNavigatorPadding + ' - ' + smartNavigatorHeaderHeight + ' - ' + FOOTER_HEIGHT + ' - ' + balancedHeader + ')'
}

export { FULL_HEIGHT, FOOTER_HEIGHT }
